import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

// 1️⃣ **NgRx & State Management**
import {PushPipe} from '@ngrx/component';

// 2️⃣ **Component Libraries**
import {UI_COMPONENTS} from './components';
import {SharedIconsModule} from '../../shared-modules/shared-icons/shared-icons.module';
import {FormsModule} from '@angular/forms';
import {UI_DIRECTIVES} from './directives';
import {UI_PIPES} from './pipes';
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {OverlayModule} from '@angular/cdk/overlay';
import {MatTooltip} from '@angular/material/tooltip';

@NgModule({
  declarations: [
    ...UI_COMPONENTS,
    ...UI_DIRECTIVES,
    ...UI_PIPES,
  ],
  imports: [
    CdkFixedSizeVirtualScroll,
    CdkVirtualScrollViewport,
    CdkVirtualForOf,
    OverlayModule,
    CommonModule,
    FormsModule,
    PushPipe,
    SharedIconsModule,
    MatTooltip
  ],
  exports: [
    ...UI_COMPONENTS,
    ...UI_DIRECTIVES,
    ...UI_PIPES,
  ],
})
export class UiComponentsModule {
}
